import {format, parse} from 'date-fns';

export function datePreparation(date: string): string {
    return format(strToDate(date), 'yyyy.MM.dd');
}

export function strToDate(date: string) {
    return new Date(parse(date, 'dd.MM.yyyy', new Date()));
}

export function dateFirstMonth(date: string) {
    return format(strToDate(date), 'MM.dd.yyyy');
}

export const minDate = {
    day: 31,
    month: 12,
    year: 1900
};

export const minDateObject = new Date(minDate.year, minDate.month, minDate.year);

export const maxDate = {
    day: 31,
    month: 12,
    year: 2100
};

export const maxDateObject = new Date(maxDate.year, maxDate.month, maxDate.year);

export function dateToStr(date: Date): string {
  return format(date, 'dd.MM.yyyy');
}

export const MY_FORMATS = {
  parse: {
    dateInput: ['DD.MM.YYYY']
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
